import { scribbleGenerator } from "./_scribbleGenerator";

// data属性が未指定のときのフォールバック値
const defaults = {
  changeSpeed: 100, // 金額変更時の伸縮スピード(1-100)
  threshold: 0.2,   // 描画を開始する画面内の表示割合(0-1)
  length: 40,       // 項目に線の長さ未設定のときの長さ(1-100)
};

/**
 * donation関数
 *
 * footer上のドネーションモジュールを初期化します。
 * - 金額ボタンの選択でscribbleの線の長さが伸縮する(長さは項目ごとにACFで設定)
 * - サポートボタンのリンク先を選択中のStripeリンクに切り替える
 * - scribbleはモジュールが画面に入ったときに描画を開始し、描き終わると停止する
 *
 * 調整用パラメータは .js-donation の data属性で変更できる:
 *   data-donation-change-speed / data-donation-threshold
 * 各ボタンの線の長さは data-donation-length (ACFの項目ごとの設定)。
 */
export function donation() {
  const module = document.querySelector(".js-donation");
  if (!module) return;

  const scribbleEl = module.querySelector(".js-donation-scribble");
  const buttons = module.querySelectorAll(".js-donation-select");
  const link = module.querySelector(".js-donation-link");
  const linkLabel = link ? link.querySelector("[data-donation-link-label]") : null;
  const selectedLinkLabel = link ? link.getAttribute("data-donation-selected-label") : "";
  if (!scribbleEl || !buttons.length) return;

  const num = (value, fallback) => {
    const n = parseFloat(value);
    return isNaN(n) ? fallback : n;
  };

  const changeSpeed = num(module.getAttribute("data-donation-change-speed"), defaults.changeSpeed);
  const threshold = num(module.getAttribute("data-donation-threshold"), defaults.threshold);

  let sg = null;
  const select = (button) => {
    buttons.forEach((b) => b.classList.toggle("is-selected", b === button));
    if (link) {
      link.setAttribute("href", button.getAttribute("data-donation-url"));
      link.classList.add("is-ready", "hover-textcolor-primarysub");
    }
    if (linkLabel && selectedLinkLabel) linkLabel.textContent = selectedLinkLabel;
    const length = num(button.getAttribute("data-donation-length"), defaults.length);
    // 属性にも常に反映しておく(生成前の初期値、およびリサイズ時のrestartで読み直される値)
    scribbleEl.setAttribute("data-scribble-max-length", length);
    if (sg) {
      // 金額変更時は初回描画よりクイックに伸縮させる
      sg.opts.speed = changeSpeed;
      sg.setMaxLength(length);
    }
  };

  buttons.forEach((button) => {
    button.addEventListener("click", () => select(button));
  });

  // 初期状態は金額未選択のまま、線の長さだけ従来の先頭項目と同じにする
  const initialLength = num(buttons[0].getAttribute("data-donation-length"), defaults.length);
  scribbleEl.setAttribute("data-scribble-max-length", initialLength);

  // モジュールが画面に入ったらscribbleの描画を開始する(常時は動かさない)
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting && !sg) {
        sg = new scribbleGenerator(scribbleEl);
        observer.disconnect();
      }
    });
  }, { threshold });
  observer.observe(scribbleEl);

  // ウィンドウの横幅が変わったらscribbleを描き直す(高さのみの変化は無視)
  let lastInnerWidth = window.innerWidth;
  window.addEventListener("resize", () => {
    if (lastInnerWidth === window.innerWidth) return;
    lastInnerWidth = window.innerWidth;
    if (sg) sg.restart();
  });
}
